import { api } from '@/services'

export const pendingHostInvoices = (params) => {
  return api.get('/web/host/invoice/pending', { params })
}

export const hostInvoices = (params) => {
  return api.get('web/host/invoice/search', { params })
}

export const createHostInvoice = (invoiceData) => {
  return api.post('/web/host/invoice/create', invoiceData)
}

export const attachHostInvoice = (invoiceData) => {
  return api.post(`/web/host/invoice/${invoiceData.id}/attachFile`, invoiceData)
}

export const updateFileHostInvoice = (invoiceData) => {
  return api.post('web/host/invoice/updateFile', invoiceData)
}
